import React, { useState } from 'react';
import './App.css';
import Office1 from './assets/images/WhatsApp Image 2026-04-17 at 22.35.27.jpeg';
import Office2 from './assets/images/WhatsApp Image 2026-04-17 at 22.35.29.jpeg';
import Office3 from './assets/images/WhatsApp Image 2026-04-17 at 22.35.31.jpeg';
import Office4 from './assets/images/WhatsApp Image 2026-04-17 at 22.38.25.jpeg';
import Office5 from './assets/images/WhatsApp Image 2026-04-17 at 22.38.26.jpeg';
import Office6 from './assets/images/WhatsApp Image 2026-04-17 at 22.38.29.jpeg';

const officeImages = [
  { id: 1, src: Office1, alt: 'Modern executive desk workspace' },
  { id: 2, src: Office2, alt: 'Contemporary office entrance' },
  { id: 3, src: Office3, alt: 'Private office cubicle' },
  { id: 4, src: Office4, alt: 'Professional office conference area' },
  { id: 5, src: Office5, alt: 'Executive office corridor' },
  { id: 6, src: Office6, alt: 'Open office workspace' },
];

function NewOffice() {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <main className="new-office">
      <section className="section-head new-office-head">
        <p className="eyebrow">New Office</p>
        <h2>Modern, Professional Workspace for Comprehensive Legal Services</h2>
        <p>
          Located in the heart of DHA, our newly established office provides a premium space thoughtfully designed 
          to meet all clientele needs. We reflect our commitment to providing clients with a professional, 
          welcoming environment designed for confidential consultations and strategic legal planning.
        </p>
        <div className="office-address-block">
          <p className="office-location-title">Bukhari Commercial Office</p>
          <p className="office-location-detail">Floor 3, Building 1C, Lane 6, Bukhari Commercial, DHA Phase 6, Karachi</p>
        </div>
      </section>

      <section className="office-gallery">
        <div className="gallery-grid">
          {officeImages.map((image) => (
            <button
              key={image.id}
              type="button"
              className="gallery-item"
              onClick={() => setSelectedImage(image)}
              aria-label={`View ${image.alt}`}
            >
              <img src={image.src} alt={image.alt} />
              <div className="gallery-overlay">
                <span className="gallery-icon">+</span>
              </div>
            </button>
          ))}
        </div>
      </section>

      <section className="office-features">
        <div className="office-features-inner">
          <div className="feature-card">
            <h3>Professional Environment</h3>
            <p>
              Thoughtfully designed spaces that foster confidence and facilitate meaningful client consultations 
              on matters of legal significance.
            </p>
          </div>
          <div className="feature-card">
            <h3>Strategic Location</h3>
            <p>
              Conveniently situated to serve clients across Karachi with accessibility and proximity to courts 
              and commercial districts.
            </p>
          </div>
          <div className="feature-card">
            <h3>Confidential Consultations</h3>
            <p>
              Private meeting spaces equipped for secure discussions on sensitive legal matters, corporate transactions, 
              and dispute resolution.
            </p>
          </div>
        </div>
      </section>

      {selectedImage && (
        <div className="modal-backdrop" role="dialog" aria-modal="true">
          <div className="modal modal-large">
            <div className="modal-header">
              <button
                type="button"
                className="modal-close"
                onClick={() => setSelectedImage(null)}
              >
                Close
              </button>
            </div>
            <img src={selectedImage.src} alt={selectedImage.alt} className="modal-image-large" />
          </div>
          <button
            type="button"
            className="modal-overlay"
            aria-label="Close modal"
            onClick={() => setSelectedImage(null)}
          />
        </div>
      )}
    </main>
  );
}

export default NewOffice;
